import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { X } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function PopupModal({ targetPage = "home" }) {
  const [popup, setPopup] = useState(null);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const timer = setTimeout(async () => {
      try {
        const source = searchParams.get("source") || "";
        const { data } = await axios.get(`${API}/popups?page=${targetPage}${source ? `&source=${source}` : ""}`);
        if (data.length > 0) {
          const pick = data[Math.floor(Math.random() * data.length)];
          setPopup(pick);
          setVisible(true);
        }
      } catch {}
    }, 2500);

    return () => clearTimeout(timer);
  }, [searchParams, targetPage]);

  const close = () => {
    setVisible(false);
  };

  const handleCta = () => {
    if (popup?.id) axios.post(`${API}/popups/${popup.id}/click`).catch(() => {});
    close();
    if (popup?.cta_link) {
      if (popup.cta_link.startsWith("http")) {
        window.open(popup.cta_link, "_blank");
      } else {
        navigate(popup.cta_link);
      }
    }
  };

  if (!popup || !visible) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 animate-fadeIn" onClick={close}>
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />
      <div
        className="relative w-full max-w-md bg-[#111116] border border-[#C9A227]/25 rounded-2xl overflow-hidden animate-scaleIn"
        onClick={(e) => e.stopPropagation()}
      >
        {popup.image_url && (
          <div className="max-h-[60vh] overflow-hidden">
            <img src={popup.image_url} alt="" className="w-full h-auto object-contain" />
          </div>
        )}

        <button
          onClick={close}
          data-testid="popup-close"
          className="absolute top-3 right-3 w-8 h-8 rounded-full bg-black/50 border border-white/10 flex items-center justify-center text-white/60 hover:text-white transition-colors"
        >
          <X size={16} />
        </button>

        <div className="p-6 sm:p-8 text-center">
          {popup.headline && (
            <h2 className="font-playfair text-xl sm:text-2xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
              {popup.headline}
            </h2>
          )}

          {popup.message && (
            <p className="text-white/60 text-sm sm:text-base leading-relaxed mb-6">
              {popup.message}
            </p>
          )}

          {popup.cta_text && (
            <button
              onClick={handleCta}
              data-testid="popup-cta"
              className="inline-block bg-[#C9A227] text-black px-8 py-3 rounded-full text-sm font-bold uppercase tracking-wider hover:bg-[#E8D18C] transition-colors"
            >
              {popup.cta_text}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
